import { apiSlice } from '@/api';
import { UserUpdate, ResetPasswordType, User } from './types';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    profile: builder.query<User, void>({
      query: () => ({
        url: 'v1/user/profile',
      }),
      transformResponse: (response: { result: User }) => response.result,
      providesTags: ['Profile'],
    }),
    updatePassword: builder.mutation<{ result: string }, ResetPasswordType>({
      query: (data) => ({
        url: `v1/user/profile/change-password`,
        method: 'PUT',
        body: data,
      }),
    }),
    updateProfile: builder.mutation<{ result: User }, UserUpdate>({
      query: (data) => ({
        url: `v1/user/profile`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
});

export const {
  useProfileQuery,
  useUpdatePasswordMutation,
  useUpdateProfileMutation,
} = userApiSlice;
